import { useTranslation } from 'react-i18next';
import React from 'react';
const TickerBOB = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "ticker-wrapper" },
        React.createElement("div", { className: "ticker-bar clickfromstore" },
            React.createElement("p", null, t('clickfromstore.ticker')),
            React.createElement("a", { className: "button button--tertiary-inverted button--arrow-right", href: props.clickFromStoreUrl }, "Logout"))));
};
export default TickerBOB;
